import { render, staticRenderFns } from "./companyMobileCode.vue?vue&type=template&id=8ff0acfc&scoped=true"
import script from "./companyMobileCode.vue?vue&type=script&lang=js"
export * from "./companyMobileCode.vue?vue&type=script&lang=js"
import style0 from "./companyMobileCode.vue?vue&type=style&index=0&id=8ff0acfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff0acfc",
  null
  
)

export default component.exports